import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import metaOverrideSet from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/MetaOverrideSet';
import {
  Layout,
} from 'Views/Page/Content/Templates/WizardTemplates/OnboardingInvestmentProfileInvestingToolboxTemplate/Layout/Layout';

const OnboardingInvestmentProfileInvestingToolboxTemplate = ({
  resource,
}) => {
  return (
    <WizardStepWrapperTemplate
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={Layout}
    />
  );
};

OnboardingInvestmentProfileInvestingToolboxTemplate.defaultProps = {
};

OnboardingInvestmentProfileInvestingToolboxTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { OnboardingInvestmentProfileInvestingToolboxTemplate };
